import React, { useCallback, useState } from "react";
import ConsolidatedService from "../../../services/ConsolidatedService";
import { ClientListRequest } from "../../client/entities/ClientListRequest";
import { ClientListResponse } from "../../client/entities/ClientListResponse";
import TableContext, { TableContextValues } from "../../task/TableContext";
import {
  applyFiltersHelper,
  calculatePageCount,
  setCurrentPageHelper,
  setPageSizeHelper,
  sortHelper,
  useEndpointData
} from "../../../utils/TableUtils";

export class ConsolidatedClientTableContextValues extends TableContextValues<
  ClientListResponse,
  { extraFilters: string[] }
> {
  max = 0;
  request: ClientListRequest = new ClientListRequest();
  setRequest: (request: ClientListRequest) => void = () => {};
}

const ConsolidatedClientTableProvider = ({
  children,
  prevRequest = undefined
}: React.PropsWithChildren<{ prevRequest?: ClientListRequest }>) => {
  const [request, setRequest] = useState(
    prevRequest ?? new ClientListRequest()
  );
  const endpoint = useCallback(
    () => ConsolidatedService.getConsolidatedClientsList(request),
    [request]
  );
  const { loading, error, response, reload } = useEndpointData(endpoint);
  const pageCount = calculatePageCount(response);
  const { sort, setSortColumn } = sortHelper(request, setRequest);
  const applySearch = (keyword: any) => {
    setRequest({ ...request, text: keyword });
  };
  const value: ConsolidatedClientTableContextValues = {
    loading,
    error,
    response,
    setSortColumn,
    currentPage: request.page,
    setCurrentPage: setCurrentPageHelper(setRequest, pageCount),
    pageCount: pageCount,
    applyFilters: applyFiltersHelper(setRequest),
    applySearch,
    reload,
    sort,
    max: response?.max ?? 0,
    pageSize: request.pagesize,
    setPageSize: setPageSizeHelper(setRequest),
    request,
    setRequest
  };

  return (
    <TableContext.Provider value={value}>{children}</TableContext.Provider>
  );
};

export default ConsolidatedClientTableProvider;
